import { msg } from "../../../../locales/translate";
export const client_registration_form_step_4 = {
	model: {
		full_name: "",
		date_of_birth: "",
		citizenship: "",
		residential_address: "",
		ownership_percentage: "",

		politicaly_exposed_person: "",
		$__politicaly_exposed_person_values: ["Yes", "No"],

		us_person: "",
		$__us_person_values: ["Yes", "No"],

		id_type: "Select ID Type...",
		$__id_type_values: ["Passport", "National ID", "Driver's License"],

		id_number: "",
		id_country: "",
		id_expiry_date: "",

		government_id: "",
		proof_of_address: "",
	},
};

export const client_registration_form_beneficiary_decorator = {
	model: {
		get $__full_name_label() { return msg("fullName_f13a64ba"); },
		get $__date_of_birth_label() { return msg("dateOfBirth"); },
		$__date_of_birth_type: "date",
		get $__citizenship_label() { return msg("citizenshipNationality"); },
		$__citizenship_type: "country",
		get $__residential_address_label() { return msg("residentialAddressStreetHouseNumberCityCountryPostalCode"); },
		get $__ownership_percentage_label() { return msg("ownershipPercentage"); },
		$__ownership_percentage_type: "number",
		get $__politicaly_exposed_person_label() { return msg("areYouAPoliticallyExposedPersonPep"); },
		$__politicaly_exposed_person_type: "radio",
		get $__us_person_label() { return msg("areYouAUSPerson"); },
		$__us_person_type: "radio",
		get $__id_type_label() { return msg("idType"); },
		$__id_type_type: "select",
		get $__id_number_label() { return msg("idNumber"); },
		get $__id_country_label() { return msg("issuingCountry"); },
		$__id_country_type: "country",
		get $__id_expiry_date_label() { return msg("expiryDate"); },
		$__id_expiry_date_type: "date",

		//files;
		get $__government_id_label() { return msg("governmentIssuedPhotoIdPassportNationalId"); },
		get $__government_id_subtitle() { return msg("mustShowFullNameDateOfBirthAndExpiryDate"); },
		$__government_id_type: "file",

		get $__proof_of_address_label() { return msg("proofOfAddressUtilityBillBankStatementOrOtherOfficialDocument3MonthsOld"); },
		get $__proof_of_address_subtitle() { return msg("mustShowNameAndResidentialAddress"); },
		$__proof_of_address_type: "file",
	},

	$__model_decorator: {
		blockless: true,

		sx: { gap: "20px" },
		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["full_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				sx: { alignItems: "end" },
				order: ["citizenship", "residential_address"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["ownership_percentage"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["politicaly_exposed_person", "us_person"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				sx: { alignItems: "end" },
				order: ["id_number", "id_country", "id_expiry_date"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["government_id"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["proof_of_address"],
			},
		],
	},
};
